import React from 'react';

const cacheService = abp.services.api.cacheService;

class CacheInfo extends React.Component {

    static propTypes = {
        cachedTime: React.PropTypes.string,
        cacheEntities: React.PropTypes.string,
        entityId: React.PropTypes.string
    };

    constructor(props) {
        super(props);
    }    

  render() {
      const { cachedTime, cacheEntities, entityId } = this.props;
      
      const handleClearCache = () => {
        cacheService.clearCache(cacheEntities, entityId).done(() => location.reload());
      } 

      return (
        <div className='cache-info'>
          <span>{`Data aktuální k: ${moment(cachedTime).format('DD.MM.YYYY HH:mm')}`}</span>
          <a href={'javascript:void(0)'} onClick={handleClearCache} className={"cache-refresh"}>
            <i className={"material-icons"}>{'refresh'}</i>
          </a>
        </div>
      )
  }
}

export default CacheInfo;


// WEBPACK FOOTER //
// ./App/components/cacheInfo.js